import AdminDataTable from "../../core/DataTable/DataTable";

export function ContactMeEditor() {
    return <AdminDataTable
    collection="contact-me"
    columns={[
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Full Name",
            field: "fullName",
            type: "text",
        },
        {
            name: "Image",
            field: "image",
            type: "image",
        },
        {
            name: "Current Position",
            field: "currentPosition",
            type: "text",
        },
        {
            name: "Message",
            field: "message",
            type: "text",
        },
        {
            name: "Email",
            field: "email",
            type: "text",
        },
        {
            name: "LinkedIn Url",
            field: "linkedinUrl",
            type: "text",
        },
        {
            name: "Github Url",
            field: "githubUrl",
            type: "text",
        },
        {
            name: "Twitter Url",
            field: "twitterUrl",
            type: "text",
        },
        {
            name: "Created at",
            field: "createdAt",
            type: "datetime",
            edit: false
        },
        {
            name: "Updated at",
            field: "updatedAt",
            type: "datetime",
            edit: false
        },
    ]}
    />
}